import { pipe, map, tap } from 'rxjs';
import { Inject } from '@angular/core';
import { Injectable } from '@angular/core';
import { AppConfig, appConfigService } from '@app/config';
import { HttpMethod, HttpService } from '@ntap/core';
import { HttpResponse } from '@angular/common/http';

@Injectable()
export class IzvjestajDownloadService {
  protected pathReportPreviewPdf: string;

  constructor(
    private httpService: HttpService,
    @Inject(appConfigService) private config: AppConfig
  ) {
    const downloadZipUrl = this.config.ntapEnvironment?.pathApiNtap + '/ui';
    this.pathReportPreviewPdf = `${downloadZipUrl}/download/report`;
  }

  protected doDownload = pipe(
    map((response: HttpResponse<any>) => {
      return this.extractResponseBlob(response);
    }),
    tap((data) => {
      this.downloadLink(data);
    })
  );

  public previewReport(body: any) {
    const url = this.pathReportPreviewPdf;
    return this.previewReportByUrl(url, body);
  }

  public previewReportByUrl(url: string, body: any) {
    return this.httpService
      .request(HttpMethod.POST, url, body, {
        responseType: 'blob',
        observe: 'response'
      })
      .pipe(
        map((response) => {
          return this.extractResponseBlob(response);
        }),
        tap((data) => {
          this.downloadLink(data);
        })
      );
  }

  private downloadLink(data: any) {
    const element = document.createElement('a');
    element.href = URL.createObjectURL(data.file);
    element.download = data.filename;
    document.body.appendChild(element);
    element.click();
    element.remove();
  }

  private extractResponseBlob(response: any): { file: Blob; filename: string } {
    const contentDisposition = response.headers.get('Content-Disposition');
    const filename = contentDisposition!.substring(
      contentDisposition!.indexOf('=') + 1
    );
    const mimeType = response.headers.get('Content-Type') || '';
    const data = {
      file: new Blob([response.body], { type: mimeType }),
      filename: filename
    };
    return data;
  }
}
